import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavigationItem } from '../desktop-navigation-dropdown/types';
import { AuthService } from '../../services/auth.service';
import { ICONS } from '../../constants/constants';

@Component({
  selector: 'app-mobile-navigation-dropdown',
  templateUrl: './mobile-navigation-dropdown.component.html',
  styleUrls: ['./mobile-navigation-dropdown.component.scss'],
})
export class MobileNavigationDropdownComponent {
  protected readonly ICONS = ICONS;

  public user$ = this.authService.user$;

  @Input() navigationItems: NavigationItem[];
  @Input() showLogout: boolean = false;

  @Output() closeMenu = new EventEmitter();
  @Output() logout = new EventEmitter();

  constructor(public authService: AuthService) {}
}
